import { LOW_HEALTH_THRESHOLD } from "./viewModels/hudViewModel";

const BASE_INTENSITY = 0.45;

/**
 * Full-viewport DOM overlay — a canvas can't paint over the sidebar/HUD, and covering the
 * whole viewport pushes the red to the true screen edges (over the dark UI, where it reads
 * regardless of the terrain behind the canvas). Pulse is CSS: see .low-health-vignette.
 */
export class LowHealthVignette {
	private readonly el: HTMLDivElement;

	constructor(parent: HTMLElement = document.body) {
		document.getElementById("low-health-vignette")?.remove();
		this.el = document.createElement("div");
		this.el.id = "low-health-vignette";
		this.el.className = "low-health-vignette";
		parent.appendChild(this.el);
	}

	update(hpRatio: number): void {
		if (hpRatio <= 0 || hpRatio > LOW_HEALTH_THRESHOLD) {
			this.el.classList.remove("active");
			return;
		}
		const depth = (LOW_HEALTH_THRESHOLD - hpRatio) / LOW_HEALTH_THRESHOLD;
		const intensity = BASE_INTENSITY + (1 - BASE_INTENSITY) * depth;
		this.el.style.setProperty("--vig-intensity", intensity.toFixed(3));
		this.el.classList.add("active");
	}

	dispose(): void {
		this.el.remove();
	}
}
